import "./style.scss"

export default function BetaTag() {
  return (
    <span className="components_beta-tag">
      beta
    </span>
  )
}
